var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceMehSolid1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C31.6304 50 37.9893 47.3661 42.6777 42.6777C47.3661 37.9893 50 31.6304 50 25C50 18.3696 47.3661 12.0107 42.6777 7.32233C37.9893 2.63392 31.6304 0 25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50ZM17.2266 17.1875C18.0554 17.1875 18.8502 17.5167 19.4363 18.1028C20.0223 18.6888 20.3516 19.4837 20.3516 20.3125C20.3516 21.1413 20.0223 21.9362 19.4363 22.5222C18.8502 23.1083 18.0554 23.4375 17.2266 23.4375C16.3978 23.4375 15.6029 23.1083 15.0169 22.5222C14.4308 21.9362 14.1016 21.1413 14.1016 20.3125C14.1016 19.4837 14.4308 18.6888 15.0169 18.1028C15.6029 17.5167 16.3978 17.1875 17.2266 17.1875ZM29.7266 20.3125C29.7266 19.4837 30.0558 18.6888 30.6419 18.1028C31.2279 17.5167 32.0228 17.1875 32.8516 17.1875C33.6804 17.1875 34.4752 17.5167 35.0613 18.1028C35.6473 18.6888 35.9766 19.4837 35.9766 20.3125C35.9766 21.1413 35.6473 21.9362 35.0613 22.5222C34.4752 23.1083 33.6804 23.4375 32.8516 23.4375C32.0228 23.4375 31.2279 23.1083 30.6419 22.5222C30.0558 21.9362 29.7266 21.1413 29.7266 20.3125ZM15.625 32.8125H34.375C35.2344 32.8125 35.9375 33.5156 35.9375 34.375C35.9375 35.2344 35.2344 35.9375 34.375 35.9375H15.625C14.7656 35.9375 14.0625 35.2344 14.0625 34.375C14.0625 33.5156 14.7656 32.8125 15.625 32.8125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceMehSolid1);
export default __webpack_public_path__ + "static/media/face-meh-solid 1.da2bbd3b41839881c7f158d16380235b.svg";
export { ForwardRef as ReactComponent };